import React,{useState,useEffect,useRef} from "react";

import Loading from "../../Loading/Loading"; 

import loadable from '@loadable/component';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import ThemeCard from "./Cards/ThemeCard";
import LoginThemeCard from "./Cards/LoginThemeCard";
import FooterThemeCard from "./Cards/FooterThemeCard";
import DashboardThemeCard from "./Cards/DashboardThemeCard";
import SidebarThemeCard from "./Cards/SidebarThemeCard";
import FilterThemeCard from "./Cards/FilterThemeCard";
import ItemCardAppDesign from "./Cards/ItemCardAppDesign";
import { appDesignSettings } from "../../../store/actions/CreateApp/appDesignSettings";
import AppMenuCardTwo from "./Cards/AppMenuCardTwo";

// npm i @loadable/component 

let lazyLoad =   <Loading/>;
  
  const Navber = loadable(() => import("../../../Navbar/UserMenu"), {
    fallback: lazyLoad  });
  
    
  
 const DesignContentAll = ({openAppDesignPopUpInn,setopenAppDesignPopUpInn})=>{
    
                const [openAppDesignPopUp,setopenAppDesignPopUp]  = useState(false);
                       const [openAppDesignPopUpInnerContent,setopenAppDesignPopUpInnerContent]  = useState("appThemes");
                        const dispatch = useDispatch();
                  
                   
                 const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
                     {
                       
                       dispatch({type: "CURSOR",payload:true  });
                   
                       dispatch({type: "CURSORTEXT",payload:CursorText})
                       dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
                       dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
                     }
                      
                     const handleMouseLeave = () => {
                       
                       dispatch({type: "CURSOR",payload:false})
                   
                       dispatch({type: "CURSORTEXT",payload:""})
                   
                       dispatch({type: "CURSORTEXTBG",payload:""})
                       dispatch({type: "CURSORTEXTCOLOR",payload:""})
                     
                   
                   }

 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
const courseData = useSelector((state)=>state?.course?.course);
const AppToken = useSelector((state)=>state?.app?.RecentAppToken);
const AppId = useSelector((state)=>state?.app?.app?.AppId);
const AppDesign = useSelector((state)=>state?.app?.appDesign);

const user_email = useSelector((state)=>state?.user?.user?.user_email);
const user = useSelector((state)=>state?.user?.user);
 const [snackbarVisible, setSnackbarVisible] = useState(false);
     const [snackbarColor, setSnackbarColor] = useState("#958FDA");
     const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
         const [loader , setLoader] =useState({status:false});
       const [animate, setAnimate] = useState(false); 
       const [openPopUp, setOpenPopUp] = useState(""); 
       
    

                   
const handleAppSettings=(type,val)=>{
   
   
   
    setLoader({status:true});
    // console.log({CourseDuration:itemArr,
    //   token:token,postIdCourse:postIdCourse ,userEmail:user_email,currentToken:currentToken,AppToken:AppToken})
    let sendObject={}
  
  
    if(type=="themeColor"){
      sendObject ={
        token:token,postIdApp:AppId ,userEmail:user_email,currentToken:currentToken,appToken:AppToken,
       editType:'themeColor',themeColor:val}
      } 
      if(type=="themeType"){
        sendObject ={
          token:token,postIdApp:AppId ,userEmail:user_email,currentToken:currentToken,appToken:AppToken,
         editType:'appTheme',appTheme:val}
        }  if(type=="loginTheme"){
          sendObject ={
            token:token,postIdApp:AppId ,userEmail:user_email,currentToken:currentToken,appToken:AppToken,
           editType:'loginSignupTheme',loginSignupTheme:val}
          } if(type=="footerTheme"){
            sendObject ={
              token:token,postIdApp:AppId ,userEmail:user_email,currentToken:currentToken,appToken:AppToken,
             editType:'footerDesign',footerDesign:val}
            } 
            if(type=="dashboardTheme"){
              sendObject ={
                token:token,postIdApp:AppId ,userEmail:user_email,currentToken:currentToken,appToken:AppToken,
               editType:'dashboardItemsDesign',dashboardItemsDesign:val}
              } 
              if(type=="sidebarTheme"){
                sendObject ={
                  token:token,postIdApp:AppId ,userEmail:user_email,currentToken:currentToken,appToken:AppToken,
                 editType:'sidebarDesign',sidebarDesign:val}
                } 
                
                if(type=="filterTheme"){
                  sendObject ={
                    token:token,postIdApp:AppId ,userEmail:user_email,currentToken:currentToken,appToken:AppToken,
                   editType:'filterPageDesign',filterPageDesign:val}
                  } 
                  
          
    const user = dispatch(appDesignSettings(sendObject));
    /* get response as Promise   */
    user.then(response => {
      // console.log(response);
      if(response){
     
    //  console.log(response);
   
     // 
    
  /* resetting Login input Fields */
  
  setLoader({status:false});
  
  setSnackbarVisible(true);
  
  setTimeout(()=>{
   
    
    setSnackbarVisible(false);
  },1000)
      }else{
      
  setLoader({status:false});
  
  setSnackbarVisible(true);
        setResponseMessage("Something Went Wrong!!!");
      setSnackbarColor("rgb(218, 143, 143) ");
      }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong!!!");
      setSnackbarColor("rgb(218, 143, 143) ");
  setLoader({status:false});
      //console.error(error);
    });
   
  }
  useEffect(()=>{
    
    setLoader({status:true});
    // console.log({
    //     token:token,postIdApp:AppId ,userEmail:user_email,currentToken:currentToken,AppToken:AppToken,
    //     editType:'themeColor'})
  
  
    
      const user = dispatch(appDesignSettings({
        token:token,postIdApp:AppId ,userEmail:user_email,currentToken:currentToken,appToken:AppToken,
        editType:''}));
      /* get response as Promise   */
      user.then(response => {
        // console.log(response);
        if(response){
       
      //  console.log(response);
     
       // 
      
    /* resetting Login input Fields */
    
    setLoader({status:false});
    
    setSnackbarVisible(true);
    
    setTimeout(()=>{
     
      
      setSnackbarVisible(false);
    },1000)
        }else{
        
    setLoader({status:false});
    
    setSnackbarVisible(true);
          setResponseMessage("Something Went Wrong!!!");
        setSnackbarColor("rgb(218, 143, 143) ");
        }
    
      }).catch(error => {
     
        //popup of error Info
        setResponseMessage("Something Went Wrong!!!");
        setSnackbarColor("rgb(218, 143, 143) ");
    setLoader({status:false});
        //console.error(error);
      });
     
    
  },[])
                   return (<div style={{}} >
<div className="appElementScroller">
<div className="gridForShowTwoSubCourses" >
      

      <ItemCardAppDesign icon={2} onMouseEnter={
                  ()=>handleMouseEnter("#fff","#222","","Click To See")}
      onMouseLeave={handleMouseLeave} setEvent={()=>{setopenAppDesignPopUp(true);setopenAppDesignPopUpInn(true);setopenAppDesignPopUpInnerContent("appThemes");}}  title="App Themes"/>
          
      <ItemCardAppDesign icon={1} setEvent={()=>{setopenAppDesignPopUp(true);setopenAppDesignPopUpInn(true);setopenAppDesignPopUpInnerContent("loginThemes");}}  title="Login Themes"/>
      <ItemCardAppDesign icon={3}  setEvent={()=>{setopenAppDesignPopUp(true);setopenAppDesignPopUpInn(true);setopenAppDesignPopUpInnerContent("footerThemes");}} title="App Footers"/>
      <ItemCardAppDesign icon={4}  setEvent={()=>{setopenAppDesignPopUp(true);setopenAppDesignPopUpInn(true);setopenAppDesignPopUpInnerContent("dashboardThemes");}}  title=" Dashboards"/>
      <ItemCardAppDesign icon={7}  setEvent={()=>{setopenAppDesignPopUp(true);setopenAppDesignPopUpInn(true);setopenAppDesignPopUpInnerContent("sidebarThemes");}} title="Sidebar "/>
      <ItemCardAppDesign icon={12} setEvent={()=>{setopenAppDesignPopUp(true);setopenAppDesignPopUpInn(true);setopenAppDesignPopUpInnerContent("filterThemes");}}  title="Filter Page"/>
      <ItemCardAppDesign  icon={11} setEvent={()=>{setopenAppDesignPopUp(true);setopenAppDesignPopUpInn(true);setopenAppDesignPopUpInnerContent("filterThemes");}}  title="Custom Links"/>
      <ItemCardAppDesign  icon={8} setEvent={()=>{setopenAppDesignPopUp(true);setopenAppDesignPopUpInn(true);setopenAppDesignPopUpInnerContent("filterThemes");}}  title="Onboarding "/>
      <ItemCardAppDesign  icon={9} setEvent={()=>{setopenAppDesignPopUp(true);setopenAppDesignPopUpInn(true);setopenAppDesignPopUpInnerContent("filterThemes");}}  title="Welcome"/>
              
      </div>
      {openAppDesignPopUp?<div className="appDesignPopUp"  style={{zIndex:99999} }>
  <div   onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} style={{cursor:"pointer",}} onClick={()=>{setopenAppDesignPopUp();setopenAppDesignPopUpInn();}}  className="appDesignPopUpOpacity"></div>

     <div   className="appDesignPopUpInner " style={{margin:'0px',background:"#fafafa",
      overflowY: "auto",zIndex:9999999,}}>
     {/* <div onMouseEnter={handleMouseEnter}
       onMouseLeave={handleMouseLeave}  
          borderRadius:"50%",right:"10px",margin:"10px",position:"absolute",
        background:"#958FDA",zIndex:99999999999}} onClick={()=>{setopenAppDesignPopUp();setopenAppDesignPopUpInn();}}   >
          <X  style={{padding:"9px",}} color="#fff" size={22}/></div> */}
          
          <div className="userInfoLiner" style={{background:"#fff"}} >
          <div className="userInfoLinerInn" style={{background:"#fff"}}>
          
            <img  className="userInfoLinerPic"src={user?.profile_pic?user?.profile_pic:"https://img.freepik.com/free-vector/illustration-businessman_53876-5856.jpg"} alt={user?.profile_pic} />
             <div className="userInfoLinerName">
          
          
             {openAppDesignPopUpInnerContent=="appThemes"? <h2>Choose Theme For Your App</h2> :
          openAppDesignPopUpInnerContent=="loginThemes"? <h2>Choose Login Screen</h2> :
           openAppDesignPopUpInnerContent=="footerThemes"? <h2>Choose Footer Design</h2>:
           openAppDesignPopUpInnerContent=="dashboardThemes"? <h2>Choose Dashboard Design</h2> :
           openAppDesignPopUpInnerContent=="sidebarThemes"? <h2>Choose Dashboard Design</h2> :
            openAppDesignPopUpInnerContent=="filterThemes"? <h2>Choose Filter Design</h2> :""}
            </div>
            </div>  <div className="userInfoLinerInn">
            <div   onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} style={{cursor:"pointer",}} onClick={()=>{setopenAppDesignPopUp();setopenAppDesignPopUpInn();}}   className="userInfoLinerButton">
          Close
            </div>
            </div>
            </div>
            
          

         <div style={{height:"85vh",overflow:"auto",}}>
         
         {openAppDesignPopUpInnerContent=="appThemes"?
           <div className="gridForWhatsNextAfterYT2" style={{alignContent:"center",textAlign:"center",marginTop:"50px",
       
        transition: 'transform 2s ease, opacity 1s ease',
      }}>
        
<ThemeCard selectTheme={(theme)=>handleAppSettings('themeType',theme)}  theme="themeOne" title="Theme One" showScreens={()=>{}} />
<ThemeCard selectTheme={(theme)=>handleAppSettings('themeType',theme)}  theme="themeTwo" title="Theme Two" showScreens={()=>{}}  />
<ThemeCard selectTheme={(theme)=>handleAppSettings('themeType',theme)}  theme="themeThree" title="Theme Three" showScreens={()=>{}} />
<ThemeCard selectTheme={(theme)=>handleAppSettings('themeType',theme)}  theme="themeFour" title="Theme Four" showScreens={()=>{}}  />
<ThemeCard selectTheme={(theme)=>handleAppSettings('themeType',theme)}  theme="themeFive" title="Theme Five" showScreens={()=>{}} />
<ThemeCard selectTheme={(theme)=>handleAppSettings('themeType',theme)}  theme="themeSix" title="Theme Six" showScreens={()=>{}} />
<ThemeCard selectTheme={(theme)=>handleAppSettings('themeType',theme)}  theme="themeSeven" title="Theme Seven" showScreens={()=>{}} />
<ThemeCard selectTheme={(theme)=>handleAppSettings('themeType',theme)}  theme="themeEight" title="Theme Eight" showScreens={()=>{}}  />
<ThemeCard selectTheme={(theme)=>handleAppSettings('themeType',theme)}  theme="themeNine" title="Theme Nine" showScreens={()=>{}}  />
<ThemeCard  selectTheme={(theme)=>handleAppSettings('themeType',theme)}  theme="themeTen"title="Theme Ten" showScreens={()=>{}} />

           
        </div> :
        openAppDesignPopUpInnerContent=="loginThemes"?<div className="gridForWhatsNextAfterYT" style={{alignContent:"center",textAlign:"center",marginTop:"50px",
       
       transition: 'transform 2s ease, opacity 1s ease',
     }}>
       
<LoginThemeCard  selectTheme={(theme)=>handleAppSettings('loginTheme',theme)}  theme="loginthemeOne" title="Login One" showScreens={()=>{}} />
<LoginThemeCard  selectTheme={(theme)=>handleAppSettings('loginTheme',theme)}  theme="loginthemeTwo" title="Login Two" showScreens={()=>{}} />
<LoginThemeCard  selectTheme={(theme)=>handleAppSettings('loginTheme',theme)}  theme="loginthemeThree" title="Login Three" showScreens={()=>{}} />
<LoginThemeCard  selectTheme={(theme)=>handleAppSettings('loginTheme',theme)}  theme="loginthemeFour" title="Login Four" showScreens={()=>{}} />
<LoginThemeCard  selectTheme={(theme)=>handleAppSettings('loginTheme',theme)}  theme="loginthemeFive" title="Login Five" showScreens={()=>{}} />
<LoginThemeCard  selectTheme={(theme)=>handleAppSettings('loginTheme',theme)}  theme="loginthemeSix" title="Login Six" showScreens={()=>{}} />
<LoginThemeCard  selectTheme={(theme)=>handleAppSettings('loginTheme',theme)}  theme="loginthemeSeven" title="Login Seven" showScreens={()=>{}} />
<LoginThemeCard  selectTheme={(theme)=>handleAppSettings('loginTheme',theme)}  theme="loginthemeEight" title="Login Eight" showScreens={()=>{}} />
<LoginThemeCard  selectTheme={(theme)=>handleAppSettings('loginTheme',theme)}  theme="loginthemeNine" title="Login Nine" showScreens={()=>{}} />
<LoginThemeCard  selectTheme={(theme)=>handleAppSettings('loginTheme',theme)}  theme="loginthemeTen" title="Login Ten" showScreens={()=>{}} />

<LoginThemeCard  selectTheme={(theme)=>handleAppSettings('loginTheme',theme)}  theme="loginthemeEleven" title="Login Eleven" showScreens={()=>{}} />
<LoginThemeCard  selectTheme={(theme)=>handleAppSettings('loginTheme',theme)}  theme="loginthemeTwelve" title="Login Twelve" showScreens={()=>{}} />
<LoginThemeCard  selectTheme={(theme)=>handleAppSettings('loginTheme',theme)}  theme="loginthemeThirteen" title="Login Thirteen" showScreens={()=>{}} />
<LoginThemeCard  selectTheme={(theme)=>handleAppSettings('loginTheme',theme)}  theme="loginthemeFourteen" title="Login Fourteen" showScreens={()=>{}} />
<LoginThemeCard  selectTheme={(theme)=>handleAppSettings('loginTheme',theme)}  theme="loginthemeFifteen" title="Login Fifteen" showScreens={()=>{}} />
<LoginThemeCard  selectTheme={(theme)=>handleAppSettings('loginTheme',theme)}  theme="loginthemeSixteen" title="Login Sixteen" showScreens={()=>{}} />
<LoginThemeCard  selectTheme={(theme)=>handleAppSettings('loginTheme',theme)}  theme="loginthemeSeventeen" title="Login Seventeen" showScreens={()=>{}} />
<LoginThemeCard  selectTheme={(theme)=>handleAppSettings('loginTheme',theme)}  theme="loginthemeEighteen" title="Login Eighteen" showScreens={()=>{}} />
<LoginThemeCard  selectTheme={(theme)=>handleAppSettings('loginTheme',theme)}  theme="loginthemeNineteen" title="Login Nineteen" showScreens={()=>{}} />
<LoginThemeCard  selectTheme={(theme)=>handleAppSettings('loginTheme',theme)}  theme="loginthemeTwenty" title="Login Twenty" showScreens={()=>{}} />

          
       </div> :  openAppDesignPopUpInnerContent=="footerThemes"?<div className="gridForWhatsNextAfterYT2" style={{alignContent:"center",textAlign:"center",marginTop:"50px",
       
       transition: 'transform 2s ease, opacity 1s ease',
     }}>
       
<FooterThemeCard  selectTheme={(theme)=>handleAppSettings('footerTheme',theme)}  theme="footerthemeOne" title="Footer One" showScreens={()=>{}} />
    
<FooterThemeCard  selectTheme={(theme)=>handleAppSettings('footerTheme',theme)}  theme="footerthemeTwo" title="Footer Two" showScreens={()=>{}} />
     
<FooterThemeCard  selectTheme={(theme)=>handleAppSettings('footerTheme',theme)}  theme="footerthemeThree" title="Footer Three" showScreens={()=>{}} />
    
<FooterThemeCard  selectTheme={(theme)=>handleAppSettings('footerTheme',theme)}  theme="footerthemeFour" title="Footer Four" showScreens={()=>{}} />
    
<FooterThemeCard  selectTheme={(theme)=>handleAppSettings('footerTheme',theme)}  theme="footerthemeFive" title="Footer Five" showScreens={()=>{}} />
    
<FooterThemeCard  selectTheme={(theme)=>handleAppSettings('footerTheme',theme)}  theme="footerthemeSix" title="Footer Six" showScreens={()=>{}} />
    
<FooterThemeCard  selectTheme={(theme)=>handleAppSettings('footerTheme',theme)}  theme="footerthemeSeven" title="Footer Seven" showScreens={()=>{}} />
    
<FooterThemeCard  selectTheme={(theme)=>handleAppSettings('footerTheme',theme)}  theme="footerthemeEight" title="Footer Eight" showScreens={()=>{}} />
</div>: openAppDesignPopUpInnerContent=="dashboardThemes"?<div className="gridForWhatsNextAfterYT" style={{alignContent:"center",textAlign:"center",marginTop:"50px",
       
       transition: 'transform 2s ease, opacity 1s ease',
     }}>
       
<DashboardThemeCard  selectTheme={(theme)=>handleAppSettings('dashboardTheme',theme)}  theme="dashboardthemeOne" title="Dashboard One" showScreens={()=>{}} />
   
<DashboardThemeCard  selectTheme={(theme)=>handleAppSettings('dashboardTheme',theme)}  theme="dashboardthemeTwo" title="Dashboard Two" showScreens={()=>{}} />
   
<DashboardThemeCard  selectTheme={(theme)=>handleAppSettings('dashboardTheme',theme)}  theme="dashboardthemeThree" title="Dashboard Three" showScreens={()=>{}} />
   
<DashboardThemeCard  selectTheme={(theme)=>handleAppSettings('dashboardTheme',theme)}  theme="dashboardthemeFour" title="Dashboard Four" showScreens={()=>{}} />
   
<DashboardThemeCard  selectTheme={(theme)=>handleAppSettings('dashboardTheme',theme)}  theme="dashboardthemeFive" title="Dashboard Five" showScreens={()=>{}} />
   
<DashboardThemeCard  selectTheme={(theme)=>handleAppSettings('dashboardTheme',theme)}  theme="dashboardthemeSix" title="Dashboard Six" showScreens={()=>{}} />
</div>:openAppDesignPopUpInnerContent=="sidebarThemes"?<div className="gridForWhatsNextAfterYT" style={{alignContent:"center",textAlign:"center",marginTop:"50px",
       
       transition: 'transform 2s ease, opacity 1s ease',
     }}>
       
<SidebarThemeCard  selectTheme={(theme)=>handleAppSettings('sidebarTheme',theme)}  theme="sidebarthemeOne" title="Sidebar One" showScreens={()=>{}} />
 
<SidebarThemeCard  selectTheme={(theme)=>handleAppSettings('sidebarTheme',theme)}  theme="sidebarthemeTwo" title="Sidebar Two" showScreens={()=>{}} />
 
<SidebarThemeCard  selectTheme={(theme)=>handleAppSettings('sidebarTheme',theme)}  theme="sidebarthemeThree" title="Sidebar Three" showScreens={()=>{}} />
 
<SidebarThemeCard  selectTheme={(theme)=>handleAppSettings('sidebarTheme',theme)}  theme="sidebarthemeFour" title="Sidebar Four" showScreens={()=>{}} />
 
<SidebarThemeCard  selectTheme={(theme)=>handleAppSettings('sidebarTheme',theme)}  theme="sidebarthemeFive" title="Sidebar Five" showScreens={()=>{}} />

<SidebarThemeCard  selectTheme={(theme)=>handleAppSettings('sidebarTheme',theme)}  theme="sidebarthemeSix" title="Sidebar Six" showScreens={()=>{}} />

<SidebarThemeCard  selectTheme={(theme)=>handleAppSettings('sidebarTheme',theme)}  theme="sidebarthemeSeven" title="Sidebar Seven" showScreens={()=>{}} />

<SidebarThemeCard  selectTheme={(theme)=>handleAppSettings('sidebarTheme',theme)}  theme="sidebarthemeEight" title="Sidebar Eight" showScreens={()=>{}} />
   </div>:openAppDesignPopUpInnerContent=="filterThemes"?<div className="gridForWhatsNextAfterYT" style={{alignContent:"center",textAlign:"center",marginTop:"50px",
       
       transition: 'transform 2s ease, opacity 1s ease',
     }}>
       
<FilterThemeCard  selectTheme={(theme)=>handleAppSettings('filterTheme',theme)}  theme="filterthemeOne" title="Filter One" showScreens={()=>{}} />

<FilterThemeCard  selectTheme={(theme)=>handleAppSettings('filterTheme',theme)}  theme="filterthemeTwo" title="Filter Two" showScreens={()=>{}} />

<FilterThemeCard  selectTheme={(theme)=>handleAppSettings('filterTheme',theme)}  theme="filterthemeThree" title="Filter Three" showScreens={()=>{}} />

<FilterThemeCard  selectTheme={(theme)=>handleAppSettings('filterTheme',theme)}  theme="filterthemeFour" title="Filter Four" showScreens={()=>{}} />

<FilterThemeCard  selectTheme={(theme)=>handleAppSettings('filterTheme',theme)}  theme="filterthemeFive" title="Filter Five" showScreens={()=>{}} />
<FilterThemeCard  selectTheme={(theme)=>handleAppSettings('filterTheme',theme)}  theme="filterthemeSix" title="Filter Six" showScreens={()=>{}} />
<FilterThemeCard  selectTheme={(theme)=>handleAppSettings('filterTheme',theme)}  theme="filterthemeSeven" title="Filter Seven" showScreens={()=>{}} />
<FilterThemeCard  selectTheme={(theme)=>handleAppSettings('filterTheme',theme)}  theme="filterthemeEight" title="Filter Eight" showScreens={()=>{}} />
  </div>:"" }
        
        </div>
          
           </div></div>:""}
   
 
</div>
</div>
) 

}
export default DesignContentAll;